export const storiesSettingsQueryKeys = {
  all: ['storiesSettings'] as const,
  settings: (entityId: number) => [...storiesSettingsQueryKeys.all, 'settings', entityId] as const
} as const;

export type StoriesSettingsQueryKeys = typeof storiesSettingsQueryKeys;
